<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="125px" inline size="mini">
      <el-form-item label="支付订单号">
        <el-input v-model="query.orderUuid" clearable placeholder="请输入支付订单号"></el-input>
      </el-form-item>
      <el-form-item label="支付流水号">
        <el-input v-model="query.transactionId" clearable placeholder="请输入支付流水号"></el-input>
      </el-form-item>
      <el-form-item label="用户信息">
        <el-input v-model="query.user" clearable placeholder="请输入用户信息"></el-input>
      </el-form-item>
      <el-form-item label="订单类型">
        <el-select v-model="query.type" clearable placeholder="请选择订单类型">
          <!-- <el-option label="押金" value="1"></el-option> -->
          <el-option label="全店充值" value="2">全店充值</el-option>
          <el-option label="商品购买" value="3">商品购买</el-option>
          <el-option label="单店充值" value="22">单店充值</el-option>
          <el-option label="无人预约" value="31">无人预约</el-option>
          <el-option label="美团团购" value="88">美团团购</el-option>
          <el-option label="抖音团购" value="99">抖音团购</el-option>
          <el-option label="优惠券续约" value="66">优惠券续约</el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付渠道">
        <el-select v-model="query.channel" clearable placeholder="请选择支付渠道">
          <el-option label="微信支付" value="1"></el-option>
          <el-option label="全店余额" value="11"></el-option>
          <el-option label="单店余额" value="21"></el-option>
          <el-option label="美团兑换" value="88"></el-option>
          <el-option label="抖音兑换" value="99"></el-option>
          <el-option label="优惠券" value="66"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单状态">
        <el-select v-model="query.status" clearable placeholder="请选择订单状态">
          <el-option label="进行中" value="0"></el-option>
          <el-option label="支付成功" value="1"></el-option>
          <el-option label="支付失败" value="2"></el-option>
          <el-option label="取消支付" value="3"></el-option>
          <el-option label="申请退款" value="4"></el-option>
          <el-option label="退款成功" value="5"></el-option>
          <el-option label="退款失败" value="6"></el-option>
          <el-option label="取消退款" value="7"></el-option>
          <el-option label="全额抵扣" value="8"></el-option>
          <!-- <el-option label="冻结成功" value="11"></el-option>
          <el-option label="解冻成功" value="12"></el-option>
          <el-option label="冻结失败" value="13"></el-option>
          <el-option label="取消冻结" value="14"></el-option> -->
        </el-select>
      </el-form-item>
      <el-form-item label="商家信息" v-show="query.type === '22'">
        <el-select v-model="query.merchant" clearable filterable placeholder="请选择商家信息">
          <el-option v-for="items in merchantNames" :key="items" :label="items" :value="items"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="代理信息" v-show="query.type === '22'">
        <el-select v-model="query.agent" clearable filterable placeholder="请选择代理信息">
          <el-option v-for="items in agentNames" :key="items" :label="items" :value="items"></el-option>
        </el-select>
      </el-form-item>
      <!-- 创建起始时间段 -->
      <el-form-item label="创建时间段">
        <el-date-picker
          v-model="ctPeriod"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="创建起始时间"
          end-placeholder="创建结束时间"
        ></el-date-picker>
      </el-form-item>
      <!-- 创建结束时间段 -->
      <el-form-item label="结束时间段">
        <el-date-picker
          v-model="ptPeriod"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="结束起始时间"
          end-placeholder="结束结束时间"
        ></el-date-picker>
      </el-form-item>
      <!-- <el-button type="warning" size="mini" @click="custody">重置</el-button> -->
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="payList" style="width: 100%" height="650px" border stripe>
        <!-- 展开行区域 -->
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-width="110px" label-position="left" inline class="expand">
              <el-form-item label="用户ID">
                <span>{{ scope.row.userUuid }}</span>
              </el-form-item>
              <el-form-item label="流水号">
                <span>{{ scope.row.transactionId }}</span>
              </el-form-item>
              <el-form-item label="授权号">
                <span>{{ scope.row.authNo }}</span>
              </el-form-item>
              <el-form-item label="支付时间">
                <span>{{ scope.row.payTime }}</span>
              </el-form-item>
              <el-form-item label="完成支付时间">
                <span>{{ scope.row.finishTime }}</span>
              </el-form-item>
              <el-form-item label="冻结时间">
                <span>{{ scope.row.freezeTime }}</span>
              </el-form-item>
              <el-form-item label="授权类型">
                <span v-if="scope.row.authType === 1">信用</span>
                <span v-else>资金</span>
              </el-form-item>
              <el-form-item label="退款金额">
                <span>{{ scope.row.refundAmount }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="uuid" label="支付订单号" width="240"></el-table-column>
        <!-- <el-table-column prop="userName" label="用户昵称"></el-table-column>
        <el-table-column prop="userCellphone" label="用户手机号"></el-table-column> -->
       <!-- <el-table-column prop="transactionId" label="支付流水号" width="240"></el-table-column> -->
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">押金充值</span>
            <span v-else-if="scope.row.type === 2">余额充值</span>
            <span v-else-if="scope.row.type === 3">商品购买</span>
            <span v-else-if="scope.row.type === 22">余额充值</span>
            <span v-else-if="scope.row.type === 31">无人预约</span>
            <span v-else-if="scope.row.type === 88">美团团购</span>
            <span v-else-if="scope.row.type === 99">抖音团购</span>
            <span v-else-if="scope.row.type === 66">优惠券续约</span>
          </template>
        </el-table-column>
        <el-table-column label="支付渠道" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.channel === 1">微信</span>
<!--            <span v-else-if="scope.row.channel === 2">支付宝</span>
            <span v-else-if="scope.row.channel === 3">微信支付分</span>
            <span v-else-if="scope.row.channel === 4">支付宝预授权</span>-->
            <span v-else-if="scope.row.channel === 5">抖音支付</span>
            <span v-else-if="scope.row.channel === 11">全店余额</span>
            <span v-else-if="scope.row.channel === 21">门店余额</span>
            <span v-else-if="scope.row.channel === 88">美团兑换</span>
            <span v-else-if="scope.row.channel === 99">抖音兑换</span>
            <span v-else-if="scope.row.channel === 66">优惠券</span>
          </template>
        </el-table-column>
        <el-table-column v-if="query.type === '22'" prop="name" label="商家" width="100" align="right"></el-table-column>
        <el-table-column v-if="query.type === '22'" prop="nickname" label="代理" width="100" align="right"></el-table-column>
        <el-table-column label="订单状态" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0">新建订单</el-tag>
            <el-tag v-if="scope.row.status === 1" type="success">支付成功</el-tag>
            <el-tag v-if="scope.row.status === 2" type="danger">支付失败</el-tag>
            <el-tag v-if="scope.row.status === 3" type="info">取消支付</el-tag>
            <el-tag v-if="scope.row.status === 4" type="warning">申请退款</el-tag>
            <el-tag v-if="scope.row.status === 5" type="success">退款成功</el-tag>
            <el-tag v-if="scope.row.status === 6" type="danger">退款失败</el-tag>
            <el-tag v-if="scope.row.status === 7" type="info">取消退款</el-tag>
            <el-tag v-if="scope.row.status === 8">全额抵扣</el-tag>
            <el-tag v-if="scope.row.status === 11" type="success">冻结成功</el-tag>
            <el-tag v-if="scope.row.status === 12" type="success">解冻成功</el-tag>
            <el-tag v-if="scope.row.status === 13" type="danger">冻结失败</el-tag>
            <el-tag v-if="scope.row.status === 14" type="info">取消冻结</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="freezeAmount" label="到账金额" width="100" align="right"></el-table-column>
        <el-table-column prop="amount" label="支付/元" width="100" align="right"></el-table-column>
        <el-table-column prop="amount1" label="使用积分" width="100" align="right"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
        <el-table-column prop="finishTime" label="完成时间" width="160"></el-table-column>
        <el-table-column label="是否退款" width="85">
          <template slot-scope="scope">
            <el-tag v-if="(scope.row.type === 22 || scope.row.type === 2) && scope.row.isRefund === 1">是</el-tag>
            <el-tag v-else-if="(scope.row.type === 22 || scope.row.type === 2) && scope.row.isRefund === 0" type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="detail" label="订单描述" width="200"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" v-if="(scope.row.type === 22 || scope.row.type === 2) && scope.row.status === 1 && scope.row.isRefund === 0" icon="el-icon-remove" size="mini" @click="refund(scope.row.uuid,scope.row.amount)">退款</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15, 30, 50, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { payList, rechargeRefund } from '@/API/order'
import { merchantNameList } from '@/API/merchant'
import { agentNameList } from '@/API/proxy'
export default {
  name: 'pay',
  data() {
    return {
      query: {
        curPage: 1,
        pageSize: 10,
        orderUuid: '',
        userCellphone: '',
        type: '',
        status: '',
        channel: '',
        ctStart: '',
        ctEnd: '',
        ptStart: '',
        ptEnd: ''
      },
      merchantNames: [],
      agentNames: [],
      // 创建起始时间段
      ctPeriod: [],
      // 创建结束时间段
      ptPeriod: [],
      // 支付订单数据列表
      payList: [],
      //   数据总条数
      total: 0
    }
  },
  created() {
    let startDate = new Date()
    startDate.setTime(startDate.getTime() - 30 * 24 * 3600 * 1000)
    this.ctPeriod[0] = startDate.getFullYear() + (startDate.getMonth() + 1 < 10 ? '-0' : '-') + (startDate.getMonth() + 1) + (startDate.getDate() < 10 ? '-0' : '-') + startDate.getDate()
    this.query.ctStart = this.ctPeriod[0]
    let endDate = new Date()
    this.ctPeriod[1] = endDate.getFullYear() + (endDate.getMonth() + 1 < 10 ? '-0' : '-') + (endDate.getMonth() + 1) + (endDate.getDate() < 10 ? '-0' : '-') + endDate.getDate()
    this.query.ctEnd = this.ctPeriod[1]

    this.getPayList()
    this.getSelectData()
  },
  methods: {
    async getPayList() {
      const { data: res } = await payList(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.payList = res.data.entities
      this.total = res.data.totalSize
    },
    async getSelectData() {
      const { data: res } = await merchantNameList({})
      if (res.code !== 200) return this.message.error(res.message)
      this.merchantNames = res.data

      const { data: res2 } = await agentNameList({})
      if (res2.code !== 200) return this.message.error(res.message)
      this.agentNames = res2.data
    },
    // 重置按钮点击事件
    custody() {
      this.query = {
        curPage: 1,
        pageSize: 10
      }
      this.ctPeriod = []
      this.ptPeriod = []
      this.getPayList()
    },
    // 搜索按钮点击事件
    seach() {
      this.query.curPage = 1
      if (this.ctPeriod != null) {
        this.query.ctStart = this.ctPeriod[0]
        this.query.ctEnd = this.ctPeriod[1]
      } else {
        this.query.ctStart = ''
        this.query.ctEnd = ''
      }
      if (this.ptPeriod != null) {
        this.query.ptStart = this.ptPeriod[0]
        this.query.ptEnd = this.ptPeriod[1]
      } else {
        this.query.ptStart = ''
        this.query.ptEnd = ''
      }
      this.getPayList()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getPayList()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.getPayList()
    },
    async refund(uuid, amount) {
      const inputAmount = await this.$prompt('请输入需要退款的金额,最大不可超过此次充值金额', '退款提示', {
        inputValue: amount,
        closeOnClickModal: false,
        inputPattern: /^\d+[.]?\d{0,2}$/,
        inputErrorMessage: '金额数字格式不正确'
      })
      console.log(inputAmount)
      this.$confirm('此操作会将用户此次充值的金额退款 ' + inputAmount.value + ' 元，且不可回退，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const { data: res } = await rechargeRefund({ orderUuid: uuid, amount: inputAmount.value })
          if (res.code !== 200) return this.$message.error(res.message)
          this.$message.success(res.message)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.expand {
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 33%;
  }
}
.numberingBox {
  cursor: pointer;
}
.el-pagination {
  margin-top: 30px;
}
.expand label {
  color: #99a9bf;
}
</style>
